import { NgIf } from '@angular/common';
import { Directive, inject, Input, OnDestroy } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { Subscription } from 'rxjs';
import { UserService } from 'services/user.service';

@Directive({
	selector: '[requiredCredential]',
	hostDirectives: [NgIf]
})
export class CredentialsDirective implements OnDestroy {

	private ngIf: NgIf<boolean> = inject(NgIf, { host: true });

	private credentialSubscription: Subscription;
	private _additionalConditions: unknown = true;
	private _credential?: CredentialType;
	@Input('requiredCredentialAnd')
	set additionalConditions(condition: unknown) {
		this._additionalConditions = condition;
		this.showTemplate();
	}

	@Input('requiredCredential')
	set credential(credential: CredentialType | undefined) {
		this._credential = credential;
		this.showTemplate();
	}

	showTemplate() {
		if (this.userService.getCredentials().some((credential: CredentialType) => credential == this._credential) && this._additionalConditions) {
			this.ngIf.ngIf = true;
		} else {
			this.ngIf.ngIf = false;
		}
	}

	constructor(private readonly userService: UserService) {
		this.credentialSubscription = userService.onCredentialsChanged().subscribe(() => { this.showTemplate(); });
	}

	ngOnDestroy() {
		this.credentialSubscription.unsubscribe();
	}
}
